<template>
  <div class="giftFloatWrap">

    <!-- ═══ 输入栏按钮：礼盒 + 红点 ═══ -->
    <button class="giftBt" :class="{ active: showCard }" @click.stop="toggleCard">
      <img v-if="current && !isEffect(current)" :src="current.coverUrl" />
      <span v-else-if="current" class="btEmoji">{{ current.icon || '🎁' }}</span>
      <span v-else class="btEmoji">🎁</span>
      <i class="giftDot" v-if="!showCard && !sentOnce"></i>
    </button>

    <!-- ═══ 惊喜礼盒卡：弹在输入栏上方 ═══ -->
    <transition name="giftCard">
      <div class="giftCard" v-if="showCard && current" @click.stop>
        <i class="closeBt" @click="showCard = false">×</i>

        <!-- 氛围光斑（纯装饰） -->
        <span class="glow glowA"></span>
        <span class="glow glowB"></span>

        <div class="cardBody">
          <!-- 礼物图：呼吸发光 + 脉冲光环 -->
          <div class="giftImgWrap">
            <span class="halo"></span>
            <img v-if="!isEffect(current)" :src="current.coverUrl" />
            <span v-else class="giftEmoji">{{ current.icon || '✨' }}</span>
          </div>

          <div class="giftInfo">
            <div class="giftLabel">{{ $i18n('giftForYou', '送出这份心意') }}</div>
            <div class="giftName">{{ current.giftName }}</div>
            <div class="giftPrice">
              <img class="gold-icon" src="@assets/icons/icon_gold_coin.png" />
              <span>{{ current.goldCoin }}</span>
            </div>
          </div>
        </div>

        <!-- 大金按钮：心跳 + 按下粒子 -->
        <button class="sendBt" :class="{ sending: sending }" @click="sendCurrent">
          <span class="btHeart">❤</span>
          <span class="btText">{{ $i18n('sendNow', '立即送出') }}</span>
          <span class="btShine"></span>
        </button>

        <div class="moreLink" @click="openFullGift">
          {{ $i18n('moreGifts', '更多礼物') }} ›
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import i18nMixin from "@/libs/i18nMixin";

export default {
  name: "GiftFloat",
  mixins: [i18nMixin],
  data() {
    return {
      giftList: [],
      current: null,
      showCard: false,
      sentOnce: false,
      sending: false,
      _loaded: false,
    };
  },
  computed: {
    ...mapGetters(["live"]),
  },
  mounted() {
    document.addEventListener('click', this.onDocClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocClick);
  },
  methods: {
    isEffect(g) { return g.giftType === 'effect'; },

    toggleCard() {
      this.showCard = !this.showCard;
      if (this.showCard) {
        if (!this._loaded) {
          this.loadGifts();
        } else {
          this.pickNext();
        }
      }
    },

    onDocClick(e) {
      if (this.showCard && this.$el && !this.$el.contains(e.target)) {
        this.showCard = false;
      }
    },

    loadGifts() {
      this.$http
          .get("/gift/getGiftList", {
            params: { liveId: this.live.id, page: 1, size: 999 },
          })
          .then((res) => {
            this.giftList = res.data || [];
            this._loaded = true;
            if (this.giftList.length) {
              this.pickNext();
            } else {
              this.showCard = false;
            }
          })
          .catch((err) => {
            console.error("[GiftFloat] 礼物加载失败:", err.message);
          });
    },

    pickNext() {
      if (!this.giftList.length) return;
      let g;
      do {
        g = this.giftList[Math.floor(Math.random() * this.giftList.length)];
      } while (this.giftList.length > 1 && g.id === this.current?.id);
      this.current = { ...g };
    },

    sendCurrent() {
      const g = this.current;
      if (!g || this.sending) return;
      this.sending = true;
      this.$http
          .post("/gift/sendGift", { giftId: g.id, liveId: this.live.id })
          .then((res) => {
            if (res.data.isSend) {
              this.sentOnce = true;
              this.$Bus.$emit("refreshCoin");
              this.$Bus.$emit("appendChatMsg", res.data.chatMsg);
              this.$toast.success(this.$i18n('sendSuccess', '发送成功！'));
              this.burstEffects();          // ★ 送出瞬间的庆祝反馈
              this.showCard = false;         // 送完关门
            } else {
              this.$toast.fail(this.$i18n('insufficientCoins', '金币不足，请稍等...'));
              this.$Bus.$emit("triggerOpenRecharge");
            }
          })
          .catch(() => {
            this.$toast.fail(this.$i18n('sendFailed', '发送失败'));
          })
          .finally(() => {
            this.sending = false;
          });
    },

    /* 送出瞬间：卡片位置迸发金色星星 + 小爱心 */
    burstEffects() {
      const card = this.$el.querySelector('.giftCard');
      if (!card) return;
      const rect = card.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const icons = ['✨', '✨', '⭐', '❤', '�html;.gold', '�html;'];
      for (let i = 0; i < 8; i++) {
        const el = document.createElement('span');
        el.className = 'giftBurstFx';
        el.textContent = icons[i % icons.length];
        el.style.left = cx + 'px';
        el.style.top = cy + 'px';
        el.style.setProperty('--dx', (Math.random() * 160 - 80) + 'px');
        el.style.setProperty('--dy', -(60 + Math.random() * 90) + 'px');
        el.style.setProperty('--rot', (Math.random() * 80 - 40) + 'deg');
        el.style.animationDelay = (i * 0.04) + 's';
        document.body.appendChild(el);
        setTimeout(() => el.remove(), 1300);
      }
    },

    openFullGift() {
      this.showCard = false;
      this.$Bus.$emit("openGift");
    },
  },
};
</script>

<style lang="less" scoped>
/* ═══ 输入栏按钮 ═══ */
.giftBt {
  position: relative;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  padding: 0;
  margin-left: 10px;
  flex-shrink: 0;
  background: linear-gradient(165deg, #fff4e0 0%, #f7dfa8 100%);
  box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.9), 0 1px 4px rgba(180, 120, 40, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.12s ease;

  img { width: 22px; height: 22px; object-fit: contain; border-radius: 4px; }
  .btEmoji { font-size: 18px; line-height: 1; }

  &:active { transform: scale(0.9); }
  &.active { box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.9), 0 1px 4px rgba(180, 120, 40, 0.5), 0 0 0 3px rgba(240, 170, 90, 0.3); }

  .giftDot {
    position: absolute;
    top: -1px;
    right: -1px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #ff4d4f;
    border: 1.5px solid #fff;
  }
}

/* ═══ 惊喜礼盒卡 ═══ */
.giftCard {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 58px;
  z-index: 4;
  width: calc(100vw - 32px);
  max-width: 320px;
  padding: 18px 16px 12px;
  box-sizing: border-box;
  /* 深夜暖场：暖棕渐变底 */
  background: linear-gradient(170deg, #4a2c1a 0%, #3a2011 55%, #2c170c 100%);
  border: 1px solid #d9a24a;
  border-radius: 14px;
  box-shadow:
      0 0 0 2px rgba(217, 162, 74, 0.25),
      0 14px 36px rgba(0, 0, 0, 0.6),
      inset 0 1px 0 rgba(255, 220, 160, 0.25);
  overflow: hidden;

  .closeBt {
    position: absolute;
    top: 6px;
    right: 8px;
    font-style: normal;
    font-size: 18px;
    color: rgba(255, 220, 160, 0.5);
    padding: 2px 6px;
    cursor: pointer;
    z-index: 2;
  }

  /* 氛围光斑：金色柔光缓慢飘 */
  .glow {
    position: absolute;
    border-radius: 50%;
    filter: blur(24px);
    pointer-events: none;

    &.glowA {
      width: 120px; height: 120px;
      top: -40px; left: -30px;
      background: rgba(255, 196, 100, 0.22);
      animation: glowDrift 6s ease-in-out infinite;
    }
    &.glowB {
      width: 90px; height: 90px;
      bottom: -30px; right: -20px;
      background: rgba(255, 120, 80, 0.18);
      animation: glowDrift 7s ease-in-out infinite reverse;
    }
  }

  .cardBody {
    position: relative;
    display: flex;
    align-items: center;
    gap: 14px;
    padding-right: 16px;
  }

  /* 礼物图：呼吸 + 光环 */
  .giftImgWrap {
    position: relative;
    width: 72px;
    height: 72px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 90%; height: 90%;
      object-fit: contain;
      border-radius: 8px;
      animation: imgBreath 2.2s ease-in-out infinite;
      filter: drop-shadow(0 2px 8px rgba(255, 190, 100, 0.45));
    }
    .giftEmoji {
      font-size: 40px;
      line-height: 1;
      animation: imgBreath 2.2s ease-in-out infinite;
      filter: drop-shadow(0 2px 8px rgba(255, 190, 100, 0.45));
    }

    /* 金色脉冲光环 */
    .halo {
      position: absolute;
      inset: 0;
      border-radius: 12px;
      border: 1.5px solid rgba(255, 200, 110, 0.5);
      animation: haloPulse 2.2s ease-out infinite;
      pointer-events: none;
    }
  }

  .giftInfo {
    flex: 1;
    min-width: 0;

    .giftLabel {
      font-size: 10px;
      letter-spacing: 3px;
      color: rgba(255, 215, 150, 0.65);
      margin-bottom: 3px;
    }
    .giftName {
      font-size: 19px;
      font-weight: bold;
      color: #ffe8c2;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
    }
    .giftPrice {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      margin-top: 6px;
      font-size: 15px;
      font-weight: bold;
      color: #ffb84d;

      .gold-icon { width: 15px; height: 15px; object-fit: contain; }
    }
  }

  /* ═══ 大金按钮：心跳 + 流光 ═══ */
  .sendBt {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;
    margin-top: 14px;
    height: 44px;
    border: none;
    border-radius: 22px;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 4px;
    color: #5a3a10;
    background: linear-gradient(180deg, #ffe2a0 0%, #f5b94e 45%, #e69f2e 100%);
    box-shadow: 0 4px 14px rgba(230, 159, 46, 0.5),
    inset 0 1px 1px rgba(255, 255, 255, 0.85);
    cursor: pointer;
    overflow: hidden;
    animation: btHeartbeat 1.6s ease-in-out infinite;
    transition: transform 0.12s ease;

    .btHeart {
      font-size: 14px;
      animation: heartBeat 1.2s ease-in-out infinite;
    }
    .btText { line-height: 44px; }

    /* 流光扫过 */
    .btShine {
      position: absolute;
      top: 0;
      left: -60%;
      width: 40%;
      height: 100%;
      background: linear-gradient(100deg, transparent 0%, rgba(255, 255, 255, 0.7) 50%, transparent 100%);
      transform: skewX(-20deg);
      animation: btShineSweep 2.6s ease-in-out infinite;
    }

    &:active { transform: scale(0.96); }

    &.sending {
      pointer-events: none;
      animation: none;
      opacity: 0.6;
    }
  }

  .moreLink {
    margin-top: 9px;
    text-align: center;
    font-size: 11px;
    color: rgba(255, 220, 170, 0.55);
    cursor: pointer;
  }
}

/* ═══ 动画 ═══ */
@keyframes imgBreath {
  0%, 100% { transform: scale(1); }
  50%      { transform: scale(1.06); }
}
@keyframes haloPulse {
  0%   { transform: scale(0.85); opacity: 0.9; }
  100% { transform: scale(1.35); opacity: 0; }
}
@keyframes glowDrift {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50%      { transform: translate(10px, 8px) scale(1.12); }
}
@keyframes btHeartbeat {
  0%, 100% { transform: scale(1); }
  12%      { transform: scale(1.03); }
  24%      { transform: scale(1); }
}
@keyframes heartBeat {
  0%, 100% { transform: scale(1); }
  30%      { transform: scale(1.3); }
  45%      { transform: scale(1); }
}
@keyframes btShineSweep {
  0%        { left: -60%; }
  55%, 100% { left: 130%; }
}

/* ═══ 送出粒子（挂 body，需全局）═══ */
:global(.giftBurstFx) {
  position: fixed;
  z-index: 9999;
  font-size: 18px;
  pointer-events: none;
  animation: giftBurstFly 1.2s cubic-bezier(0.2, 0.6, 0.4, 1) forwards;
}

@keyframes giftBurstFly {
  0% {
    opacity: 0;
    transform: translate(0, 0) rotate(0) scale(0.4);
  }
  12% { opacity: 1; }
  100% {
    opacity: 0;
    transform: translate(var(--dx), var(--dy)) rotate(var(--rot)) scale(1.4);
  }
}
</style>
